import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

import {
  useRoute,
} from 'vue-router';

export interface IHeaderTextLink {
  title: string;
  alternateTitle?: string;
  path?: string;
  url?: string;
  event?: string;
  userOnly?: boolean;
  hidden?: boolean;
  isMobile?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderTextLinkButton',
  props: {
  title: {
    type: String,
    required: true,
  },
  alternateTitle: {
    type: String,
    required: false,
    default: '',
  },
  path: {
    type: String,
    required: false,
    default: '',
  },
  url: {
    type: String,
    required: false,
    default: '',
  },
  block: {
    type: Boolean,
    required: false,
  },
  event: {
    type: String,
    default: '',
  },
},
  setup(__props) {



const mainRoute = useRoute();




return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (__props.path.startsWith('http'))
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: _normalizeClass(["rounded-md px-4 py-2.5 text-left text-base font-normal text-neutral-1 no-underline hover:bg-[#A3D4F2]/[22%] lg:text-lg", {
      'font-semibold': __props.title === _unref(mainRoute).name,
    }]),
        target: "_blank",
        rel: "noopener noreferrer",
        href: __props.path,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(__props.event || 'click')))
      }, _toDisplayString(__props.alternateTitle || __props.title), 11, _hoisted_1))
    : (_openBlock(), _createBlock(_component_RouterLink, {
        key: 1,
        class: _normalizeClass(["rounded-md px-4 py-2.5 text-left text-base font-normal text-neutral-1 no-underline hover:bg-[#A3D4F2]/[22%] lg:text-lg", {
      'font-semibold': __props.title === _unref(mainRoute).name,
    }]),
        target: __props.url ? '_blank' : undefined,
        rel: "noopener noreferrer",
        href: __props.url,
        to: __props.path,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(__props.event || 'click')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.alternateTitle || __props.title), 1)
        ]),
        _: 1
      }, 8, ["class", "target", "href", "to"]))
}
}

})